import { useHookstate } from "@hookstate/core";
import { useState, useEffect } from "react";
import { useP2PSettings } from "./useP2PSettings";
import * as Sentry from "@sentry/react";
import { readerDataStore } from "../../../hookstate/readerDataStore";
import { readerSettingsStore } from "../../../hookstate/readerSettingsStore";

export function useReaderLoaded() {
  const loaded = useHookstate(readerDataStore.loaded).get();
  const [timedOut, setTimedOut] = useState(false);
  useEffect(() => {
    if (!loaded) {
      const timeout = setTimeout(() => {
        try {
          Sentry.captureException(new Error("Reader failed to load"), {
            extra: { ...window.location },
          });
        } catch {
          // Sentry may be blocked by ad blockers
        }
        setTimedOut(true);
      }, 30000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [loaded]);

  const { p2pEnabled } = useP2PSettings();
  const releaseData = useHookstate(readerDataStore.releaseData).get({
    noproxy: true,
  });
  useEffect(() => {
    if (releaseData) {
      if (!releaseData?.can_edit && !releaseData?.is_augmented) {
        readerSettingsStore.p2pEnabled.set(false);
      }
    }
  }, [p2pEnabled, releaseData]);

  return { loaded, timedOut };
}
